import { type ComponentProps } from 'react';

import { cn } from '@/util/utils';
import { WATERMARK_PATH, WATERMARK_VIEW_BOX } from '@/components/Brand/brand-paths';

/**
 * The oversized monogram the brand panel uses as texture, at --opacity-watermark (6%, from the
 * Brand rules frame). Always decorative; the parent positions and crops it.
 */
export function Watermark({ className, ...props }: Omit<ComponentProps<'svg'>, 'children'>) {
    return (
        <svg
            viewBox={WATERMARK_VIEW_BOX}
            fill="none"
            aria-hidden
            className={cn('pointer-events-none block opacity-(--opacity-watermark)', className)}
            {...props}
        >
            <path fillRule="evenodd" clipRule="evenodd" d={WATERMARK_PATH} fill="currentColor" />
        </svg>
    );
}
